import MetricDetail from './MetricDetail';

export default MetricDetail;
